import { PERMISSION_CATALOG } from "../constants/permissionCatalog";

const ALL_PERMISSIONS = new Set(PERMISSION_CATALOG);

const permissionsByModule = (...modules) => {
  const moduleSet = new Set(modules);
  return new Set(PERMISSION_CATALOG.filter(code => moduleSet.has(code.split(".")[0])));
};

/** Espelha ROLE_BASE_PERMISSIONS do backend (authorization_rules.py). */
export const ROLE_BASE_PERMISSIONS = {
  ADMIN: ALL_PERMISSIONS,
  ADMINISTRATIVO: ALL_PERMISSIONS,
  GESTOR: permissionsByModule(
    "dashboard",
    "alunos",
    "monitores",
    "nucleos",
    "salas",
    "turmas",
    "matriculas",
    "frequencia",
    "avaliacoes",
    "planejamentos",
    "galeria",
    "relatorios",
    "ocorrencias"
  ),
  COORDENADOR: permissionsByModule(
    "dashboard",
    "alunos",
    "turmas",
    "matriculas",
    "frequencia",
    "avaliacoes",
    "planejamentos",
    "galeria",
    "relatorios",
    "ocorrencias"
  ),
  MONITOR: permissionsByModule("frequencia", "avaliacoes", "planejamentos", "galeria", "ocorrencias"),
};
ROLE_BASE_PERMISSIONS.SECRETARIA = ROLE_BASE_PERMISSIONS.GESTOR;

export function roleHasBasePermission(role, permissionCode) {
  const base = ROLE_BASE_PERMISSIONS[role];
  if (!base) return false;
  return base.has(permissionCode);
}
